import Message from "./Message";
export * from "./Message";
export default Message;